import { useCallback, useRef } from 'react'

export const useScrollToBottom = () => {
  const containerRef = useRef<HTMLDivElement>(null)

  const scrollToBottom = useCallback(() => {
    const element = containerRef.current

    if (!element) {
      return
    }

    requestAnimationFrame(() => {
      element.scrollTo({
        top: element.scrollHeight,
        behavior: 'auto',
      })
    })
  }, [])

  return {
    containerRef,
    scrollToBottom,
  }
}
